export var PaymentGate = /*#__PURE__*/function (PaymentGate) {
  PaymentGate[PaymentGate["NC"] = 1] = "NC";
  PaymentGate[PaymentGate["BRAINTREE"] = 2] = "BRAINTREE";
  PaymentGate[PaymentGate["MOIP"] = 3] = "MOIP";
  PaymentGate[PaymentGate["PAYMENTWALL"] = 4] = "PAYMENTWALL";
  PaymentGate[PaymentGate["IAPAPPLE"] = 5] = "IAPAPPLE";
  PaymentGate[PaymentGate["IAPGOOGLE"] = 6] = "IAPGOOGLE";
  PaymentGate[PaymentGate["CODE"] = 7] = "CODE";
  PaymentGate[PaymentGate["STRIPE"] = 8] = "STRIPE";
  return PaymentGate;
}(PaymentGate || {});